export default __webpack_public_path__ + "static/media/skylar.d2bff5f4.webp";